<template>
  <div class="c-tabs-content">
    <el-cascader
      v-model="keyword"
      :options="completeData"
      :props="{ multiple: true, emitPath: false, label: 'title' }"
      :show-all-levels="false"
      collapse-tags
      clearable
      style="width: 220px"
      @change="$emit('on-complete', $event)"
    ></el-cascader>

    <div class="c-keyword">
      <Spin v-if="loading" size="large" fix />
      <template v-else-if="empty">
        <div class="c-empty">
          <Icon type="ios-filing-outline" size="58" color="#efefef" />
          <span>可筛选分类查看推荐抖音达人或直接搜索抖音达人</span>
        </div>
      </template>
      <div v-else class="c-list">
        <div class="c-list-head">
          <template v-if="keyqueried">
            <a href="javascript:;" @click.prevent="$emit('on-clear')"><Icon type="ios-arrow-back" />返回</a>
            <span style="padding-left: 6px"> | “{{ author }}”的相似抖音达人</span>
          </template>
          <span v-else>{{ queryWord ? queryWord.name : '' }}类抖音达人推荐：</span>
        </div>
        <div class="c-list-body">
          <div class="c-list-item" v-for="word in dropData" :key="word.id">
            <Avatar :src="word.avatar" />
            <div class="c-item-body">
              <span class="name">{{ word.name }}(ID：{{ word.aweme }})</span>
              <span class="num">
                <span style="min-width: 120px">粉丝：{{ word.num }}</span>
                <span>分类：{{ queryWord ? queryWord.name : '' }}</span>
              </span>
            </div>
            <span class="operate">
              <a href="javascript:;" v-if="check(word.id)" class="c-checked-span">已加</a>
              <a v-else href="javascript:;" :class="{ 'c-checked-span': disabled }" @click="selectedHandle(word)">添加</a>
              <a href="javascript:;" v-if="!keyqueried" @click="queryHandle(word)">找相似</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'KeyWord',
  props: {
    value: {
      type: String
    },
    data: {
      type: Array
    },
    completeData: {
      type: Array
    },
    words: {
      type: Array,
      required: true
    },
    recommons: {
      type: Array
    },
    queryWord: {
      type: Object,
      required: true
    },
    author: {
      type: String
    },
    loading: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    keyword: {
      get() {
        return this.queryWord && this.queryWord.key
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    keyqueried() {
      return this.recommons.length
    },
    dropData() {
      return this.keyqueried ? this.recommons : this.data
    },
    check() {
      return (id) => this.words.map((ret) => ret.id).includes(id)
    },
    empty() {
      return !isArray(this.dropData) || !this.dropData.length
    }
  },
  methods: {
    queryHandle(item) {
      this.$emit('on-search', {
        id: item.id,
        name: item.name,
        aweme: item.aweme,
        tag_type: 'KEYWORD'
      })
    },
    selectedHandle(word) {
      if (this.disabled) return
      this.$emit('on-select', [word])
    }
  }
}
</script>
<style lang="scss" scoped>
.c-action-search {
  width: 100%;
}

.c-keyword {
  position: relative;
  height: 329px;
  padding-bottom: 12px;

  .c-list,
  .c-empty {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .c-list {
    position: relative;

    .c-list-head {
      line-height: 34px;
      height: 34px;
      background-color: #fafbfe;
      color: #333;
      font-size: 14px;
      padding-left: 13px;
    }

    .c-list-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      height: calc(100% - 34px);
      padding: 8px 12px 0;
    }

    .c-list-item {
      display: flex;
      margin-bottom: 4px;
      align-items: center;

      span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        display: inline-block;
      }

      .c-item-body {
        display: flex;
        width: 400px;
        padding: 0 10px;
        flex-direction: column;

        .num {
          color: #999;

          span {
            line-height: 14px;
          }
        }

        .name {
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: #333;
          line-height: 23px;
        }
      }

      .operate {
        width: 76px;

        a {
          display: inline-block;

          &:last-child {
            margin-left: 12px;
          }
        }

        .c-checked-span {
          color: #a8d7ff;
          cursor: default;
        }
      }
    }
  }

  .c-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      color: #c1c1c1;
      padding-top: 8px;
    }
  }
}

.search-suggest-wrap {
  background-color: #ffffff;

  ul {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    max-height: 240px;

    li {
      padding: 0 12px 0;
      margin-bottom: 6px;
      display: flex;
      flex-flow: column;

      &:hover {
        background-color: #f3f3f3;
      }

      span:nth-child(1) {
        font-size: 14px;
        line-height: 22px;
      }

      span:nth-child(2) {
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }
    }
  }
}

::v-deep .ivu-select-dropdown-list {
  margin-bottom: 0;
}
</style>
